import moment from 'moment'

export default {
	methods: {
		formatDate (date) {
			return moment(date).format('DD/MM/YYYY');
		},
		formatHour(date) {
			return moment(date).format("hh:mm");
		},
		format (item) {
			const day = [item[2]].toString().length === 2 ?
				`${item[2]}` : `0${item[2]}`
			const month = [item[1]].toString().length === 2 ?
				`${item[1]}` : `0${item[1]}`
			return `${day}/${month}/${item[0]}`
		},
		day () {
			return moment().format('DD/MM/YYYY')
		},
	}
}


// WEBPACK FOOTER //
// ./src/mixins/date.js